import BaseResource from './BaseResource'
import { Macro } from 'types'

export default class Macros extends BaseResource<Macro> {
  endpoint = 'v1/macros'
}
